module.exports = __webpack_public_path__ + "static/img/table-1.065911a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/table-1.png
// module id = j+HD
// module chunks = 0